module.exports = __webpack_public_path__ + "img/itx-file-type-mp3.ab9b3c24.svg";